import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { JsonReportDataModel } from '@base/modules/rest/print-template/model/json-report-data.model';
import { AppConfiguration } from '../../../../app-configuration';
import { ObjectPrintRequestModel } from './model/object-print-request.model';

@Injectable()
export class PrintTemplateRestService {
  controllerUrl: string;

  constructor(private httpClient: HttpClient,
              private appConfiguration: AppConfiguration) {
    this.controllerUrl = this.appConfiguration.serverApiUrl + '/secured/print';
  }

  getAllTemplates(payload: { objectName: string; recordId: number }): Observable<any> {
    const queryParams: any = {};
    if (payload.recordId) {
      queryParams.recordId = payload.recordId;
    }
    return this.httpClient.get(`${this.controllerUrl}/${payload.objectName}`, {params: queryParams});
  }

  printDocument(payload: { objectName: string; data: ObjectPrintRequestModel }): Observable<HttpResponse<Blob>> {
    return this.httpClient.post(
      `${this.controllerUrl}/${payload.objectName}/print`,
      payload.data,
      {
        responseType: 'blob',
        observe: 'response',
      }
    );
  }

  getPrintJson(payload: {
    objectName: string;
    data: ObjectPrintRequestModel;
  }): Observable<JsonReportDataModel> {
    return this.httpClient.post<JsonReportDataModel>(`${this.controllerUrl}/${payload.objectName}/pdf/json`, payload.data);
  }

}
